export default {
  dayNames: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П\'ятниця', 'Субота'],
  dayNamesShort: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  dayNamesMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  monthNames: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
  monthNamesShort: ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
  today: 'Сьогодні',
  clear: 'Очистити',
  weekHeader: 'Тж',
  firstDayOfWeek: 1,
  dateFormat: 'dd.mm.yy',
  weak: 'Слабкий',
  medium: 'Середній',
  strong: 'Сильний',
  passwordPrompt: 'Введіть пароль',
  emptyMessage: 'Немає результатів',
  emptyFilterMessage: 'Немає результатів',
  pending: 'Очікує',
  chooseYear: 'Вибрати рік',
  chooseMonth: 'Вибрати місяць',
  chooseDate: 'Вибрати дату',
  prevDecade: 'Попереднє десятиліття',
  nextDecade: 'Наступне десятиліття',
  prevYear: 'Попередній рік',
  nextYear: 'Наступний рік',
  prevMonth: 'Попередній місяць',
  nextMonth: 'Наступний місяць',
  prevHour: 'Попередня година',
  nextHour: 'Наступна година',
  prevMinute: 'Попередня хвилина',
  nextMinute: 'Наступна хвилина',
  prevSecond: 'Попередня секунда',
  nextSecond: 'Наступна секунда',
  am: 'ранку',
  pm: 'вечора',
  selectionMessage: '{0} елементів вибрано',
  emptySelectionMessage: 'Немає вибраних елементів',
  emptySearchMessage: 'Немає результатів',
  aria: {
    trueLabel: 'Так',
    falseLabel: 'Ні',
    nullLabel: 'Не вибрано',
    star: '1 зірка',
    stars: '{star} зірок',
    selectAll: 'Всі елементи вибрано',
    unselectAll: 'Всі елементи скасовано',
    close: 'Закрити',
    previous: 'Попередній',
    next: 'Наступний',
    navigation: 'Навігація',
    scrollTop: 'Прокрутити вгору',
    moveTop: 'Перемістити вгору',
    moveUp: 'Перемістити вище',
    moveDown: 'Перемістити нижче',
    moveBottom: 'Перемістити вниз',
    moveToTarget: 'Перемістити до цілі',
    moveToSource: 'Перемістити до джерела',
    moveAllToTarget: 'Перемістити все до цілі',
    moveAllToSource: 'Перемістити все до джерела',
    pageLabel: 'Сторінка {page}',
    firstPageLabel: 'Перша сторінка',
    lastPageLabel: 'Остання сторінка',
    nextPageLabel: 'Наступна сторінка',
    prevPageLabel: 'Попередня сторінка',
    rowsPerPageLabel: 'Рядків на сторінку',
    jumpToPageDropdownLabel: 'Перейти на сторінку',
    jumpToPageInputLabel: 'Перейти на сторінку',
    selectRow: 'Вибрати рядок',
    unselectRow: 'Скасувати вибір рядка',
    expandRow: 'Розгорнути рядок',
    collapseRow: 'Згорнути рядок',
    showFilterMenu: 'Показати меню фільтра',
    hideFilterMenu: 'Приховати меню фільтра',
    filterOperator: 'Оператор фільтра',
    filterConstraint: 'Обмеження фільтра',
    editRow: 'Редагувати рядок',
    saveEdit: 'Зберегти редагування',
    cancelEdit: 'Скасувати редагування',
    listView: 'Вигляд списку',
    gridView: 'Вигляд сітки',
    slide: 'Слайд',
    slideNumber: '{slideNumber}',
    zoomImage: 'Збільшити зображення',
    zoomIn: 'Збільшити',
    zoomOut: 'Зменшити',
    rotateRight: 'Повернути праворуч',
    rotateLeft: 'Повернути ліворуч'
  }
}
